import FJAppConstant from '../constants/FJAppConstant';
import FJImageToImageConfig from './appConfig/FJImageToImageConfig';
import FJImageManipulationConfig from './appConfig/FJImageManipulationConfig';
import FJFaceSwapConfig from './appConfig/FJFaceSwapConfig';
import FJImageEnhancerConfig from './appConfig/FJImageEnhancerConfig';
import FJTextToImageConfig from './appConfig/FJTextToImageConfig';
import FJClothesChangerConfig from './appConfig/FJClothesChangerConfig';
import FJImageExtenderConfig from './appConfig/FJImageExtenderConfig';
import FJAIVideoGeneratorConfig from './appConfig/FJAIVideoGeneratorConfig.js';
import { RELEASE, LOCAL } from '../constants/FJEvnConstant';
import FJFake3dConfig from './appConfig/FJFake3dConfig';
import FJObjectEraseConfig from './appConfig/FJObjectEraseConfig';
import FJPhotoRemoveBgConfig from './appConfig/FJPhotoRemoveBgConfig';
import FJAIAudioConfig from './appConfig/FJAIAudioConfig.js';
import FJVideoRemoveBgConfig from './appConfig/FJVideoRemoveBgConfig';

const environment = import.meta.env.MODE; // 当前环境
const currentProjectType = import.meta.env.VITE_CURRENT_PROJECT_TYPE; // 当前项目

const VERSION_CONFIG = {
    version: '1.0.1.2.27',
    codecResourceVersion: '1.0.4', // code 路径的版本
    wasmResourceVersion: '1.0.4', // wasm 资源路径的版本
    workVersion: '1.0.2', // 解码 mask 的版本
};

//#region 配置信息
// 链接的映射
const URL_KEYS = {
    'old-photo-restoration': FJAppConstant.PHOTO_RESTORATION,
    'face-swap': FJAppConstant.FACE_SWAP,
    'photo-colorizer': FJAppConstant.PHOTO_COLORIZE,
    'text-to-image': FJAppConstant.TEXT_TO_IMAGE,
    'image-upscaler': FJAppConstant.IMAGE_ENHANCER,
    'image-to-image': FJAppConstant.IMAGE_TO_IMAGE,
    'clothes-changer': FJAppConstant.CLOTHES_CHANGER,
    'image-extender': FJAppConstant.IMAGE_EXTENDER,
    '3d-photo-animation': FJAppConstant.FAKE_3D,
    'object-remover': FJAppConstant.OBJECT_ERASER,
    'image-background-remover': FJAppConstant.PHOTO_REMOVE_BG,
    'video-generator': FJAppConstant.AI_VIDEO_GENERATOR,
    'music-generator': FJAppConstant.AI_AUDIO_GENERATOR,
    'video-background-remover': FJAppConstant.VIDEO_REMOVE_BG,
};
const APP_TYPE_CONFIG = {
    [FJAppConstant.IMAGE_TO_IMAGE]: FJImageToImageConfig,
    [FJAppConstant.PHOTO_RESTORATION]: FJImageManipulationConfig,
    [FJAppConstant.PHOTO_COLORIZE]: FJImageManipulationConfig,
    [FJAppConstant.IMAGE_ENHANCER]: FJImageEnhancerConfig,
    [FJAppConstant.TEXT_TO_IMAGE]: FJTextToImageConfig,
    [FJAppConstant.IMAGE_EXTENDER]: FJImageExtenderConfig,
    [FJAppConstant.FACE_SWAP]: FJFaceSwapConfig,
    [FJAppConstant.CLOTHES_CHANGER]: FJClothesChangerConfig,
    [FJAppConstant.FAKE_3D]: FJFake3dConfig,
    [FJAppConstant.OBJECT_ERASER]: FJObjectEraseConfig,
    [FJAppConstant.PHOTO_REMOVE_BG]: FJPhotoRemoveBgConfig,
    [FJAppConstant.AI_VIDEO_GENERATOR]: FJAIVideoGeneratorConfig,
    [FJAppConstant.AI_AUDIO_GENERATOR]: FJAIAudioConfig,
    [FJAppConstant.VIDEO_REMOVE_BG]: FJVideoRemoveBgConfig,
};
// endregion

let appType;
if (window.isEditPage) {
    appType = window.aiToolName;
} else {
    appType = currentProjectType || FJAppConstant.IMAGE_TO_IMAGE;
    const localPath = window.location.pathname;
    const keys = localPath.split('/');
    for (const key in URL_KEYS) {
        const result = keys.find(value => value && value === key);
        if (result) {
            appType = URL_KEYS[key];
            break;
        }
    }
}

const FJConfig = {
    appType: appType,
    URL_KEYS: URL_KEYS,
    version: VERSION_CONFIG.version,
    // TODO AI工具整体改动的时候，需要修改这个路径
    webSocketUrl:
        environment === LOCAL
            ? 'https://www.smartvideomaker.com/'
            : environment !== RELEASE
              ? 'https://www.smartvideomaker.com/'
              : 'https://app.flexclip.com/',
    serverPath:
        environment === LOCAL
            ? 'http://localhost:5173/'
            : environment !== RELEASE
              ? 'https://www.smartvideomaker.com/'
              : 'https://www.flexclip.com/',
    requestPath:
        environment === LOCAL
            ? 'http://localhost:5173'
            : environment !== RELEASE
              ? 'https://www.smartvideomaker.com'
              : 'https://www.flexclip.com',
    languagePath: environment === LOCAL ? `/language/local.` : `/app/ai-tools/language/local.`,
    imgPath: environment === LOCAL ? `/public/img/` : `/app/ai-tools/img/`,
    codecVersion: VERSION_CONFIG.codecResourceVersion,
    wasmVersion: VERSION_CONFIG.wasmResourceVersion,
    workVersion: VERSION_CONFIG.workVersion,
    // TODO AI工具整体改动的时候，需要修改这个路径
    decodeMaskDataWorkPath:
        environment === LOCAL
            ? '/lib/work/decodeMaskDataWork.js'
            : environment !== RELEASE
              ? '/app/ai-tools/lib/work/decodeMaskDataWork.js'
              : '/app/ai-tools/lib/work/decodeMaskDataWork.js',
    addPointImage: environment === LOCAL ? '/public/img/add-point.svg' : '/app/ai-tools/img/add-point.svg',
    removePointImage: environment === LOCAL ? '/public/img/remove-point.svg' : '/app/ai-tools/img/remove-point.svg',
    selectedPointImage: environment === LOCAL ? '/public/img/select.svg' : '/app/ai-tools/img/select.svg',

    usePhotoTextToImageHistoryNullPng:
        environment === LOCAL ? '/public/img/text-to-image-null.png' : '/app/ai-tools/img/text-to-image-null.png',
    usePhotoImageToImageHistoryNullPng:
        environment === LOCAL ? '/public/img/img-to-image-null.png' : '/app/ai-tools/img/img-to-image-null.png',
    strokeImageBaseUrl: environment === LOCAL ? '/public/img/stroke/' : '/app/ai-tools/img/stroke/',
    eyedropperSupportBrowser: ['Chrome', 'Edge', 'Opera'], // 取色器浏览器支持
    notSupportBrowserImage:
        environment === LOCAL ? '/public/img/google-thumbnail.png' : '/app/ai-tools/img/google-thumbnail.png',
};
//#endregion
console.log('version:::', VERSION_CONFIG.version, appType);
Object.assign(FJConfig, APP_TYPE_CONFIG[appType]);
// window.isEditPage = true;
export { APP_TYPE_CONFIG };
export default FJConfig;
